
export const profileItem = [
    {
        id: 1,
        icon: "/assets/icons/avatar.svg",
        title: "Osobni podatci",
        path: "/personal-information"
    },
    {
        id: 2,
        icon: "/assets/icons/awards.svg",
        title: "Sakupljeni bodovi",
        path: "/collect-points"
    },
    {
        id: 3,
        icon: "/assets/icons/history.svg",
        title: "Povijest kodova i nagrada",
        path: "/points"
    },
    {
        id: 4,
        icon: "/assets/icons/share.svg",
        title: "Pozovi prijatelje",
        path: "/share"
    },
    {
        id: 5,
        icon: "/assets/icons/lock-password.svg",
        title: "Promijeni lozinku",
        path: "/change-password"
    },
]